<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="申请售后时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'
export default {
  data() {
    return {
      dateTime: [],
      query: {}
    }
  },
  methods: {
    handleDownload() {
      const params = {}
      if (this.dateTime && this.dateTime.length > 0) {
        params.applyTimeStart = this.dateTime[0]
        params.applyTimeEnd = this.dateTime[1]
      }
      return this.$common.confirm('是否确认导出')
        .then(() => goodsOrderApi.exportAfterOrderClaim(params)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    }
  }
}
</script>

<style>
</style>

